import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class NumberRangeQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.NUMBER_RANGE;
  color: string;
  startIcon: string;
  endIcon: string;
  min: number;
  max: number;
  step: number;
  startLabel: string;
  endLabel: string;
  dualKnobs: boolean;
  defaultValue: number;
  showTicks: boolean;
  showSliderValue: boolean;

  constructor(options: any = {}) {
    super(options);
    this.color = options['color'] || 'primary';
    this.startIcon = options['startIcon'] || '';
    this.endIcon = options['endIcon'] || '';
    this.min = options['min'] || 0;
    this.max = options['max'] || 0;
    this.step = options['step'] || 1;
    this.startLabel = options['startLabel'] || void 0;
    this.endLabel = options['endLabel'] || void 0;
    this.dualKnobs = options['dualKnobs'] || false;
    this.defaultValue = options['defaultValue'] || void 0;
    this.showTicks = options['showTicks'] || false;
    this.showSliderValue = options['showSliderValue'];
  }
}
